import IconInfo from '@apollo/icons/default/IconInfo.svg';
import { Spinner, Tooltip } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { format } from 'src/lib/format';

import { ExplorerResult } from '../../hooks/useExplorerState/useExplorerResponses';
const isSuccessResponse = (status: number) => status >= 200 && status <= 399;

interface ResultStatusProps {
  operationResult: ExplorerResult;
  isMockingResponses: boolean;
}
export const ResultStatus = ({
  operationResult,
  isMockingResponses,
}: ResultStatusProps) => {
  const lastResult =
    operationResult?.type === 'loading'
      ? operationResult.previousResponse
      : operationResult;

  return (
    <div className="flex flex-none items-center gap-2 text-xs text-primary">
      {operationResult?.type === 'loading' ||
      (operationResult?.type === 'response' && operationResult.data.hasNext) ? (
        <Spinner variant="neutral" size="tiny" className="mr-1" />
      ) : (
        isMockingResponses && (
          <Tooltip label="Responses are being mocked on the client">
            <IconInfo className="mr-1" />
          </Tooltip>
        )
      )}

      {lastResult?.type === 'response' && lastResult.data.type === 'result' && (
        <>
          <Tooltip label="HTTP status">
            <span
              className={classnames(
                'ml-2 inline-block',
                !isSuccessResponse(lastResult.data.status)
                  ? 'text-error'
                  : 'text-success',
              )}
            >
              {lastResult.data.status}
            </span>
          </Tooltip>
          <Tooltip label="Response duration">
            <div className="border-x border-primary px-2">
              {format.ms(lastResult.data.endTime - lastResult.data.startTime)}
            </div>
          </Tooltip>
          <Tooltip label="Response size">
            <span>{format.bytes(lastResult.data.size)}</span>
          </Tooltip>
        </>
      )}
    </div>
  );
};
